export const assistantTradeStrategyRegistry = [
  {
    key: "scalping",
    label: "Scalping",
    description:
      "Short-horizon trade analysis focused on quick price moves and tight execution.",
  },
  {
    key: "sharp_money",
    label: "Sharp Money",
    description:
      "Trade analysis based on informed flow, market positioning, and price agreement.",
  },
  {
    key: "market_making",
    label: "Market Making",
    description:
      "Trade analysis for quoting both sides and managing spread and inventory risk.",
  },
  {
    key: "build_with_ai",
    label: "Build with AI",
    description:
      "Work with the assistant to build a market-specific strategy from the available signals and tooling.",
  },
] as const

export type AssistantTradeStrategy =
  (typeof assistantTradeStrategyRegistry)[number]["key"]

export const assistantTradeStrategyKeys = assistantTradeStrategyRegistry.map(
  strategy => strategy.key,
) as [AssistantTradeStrategy, ...AssistantTradeStrategy[]]

export function getAssistantTradeStrategyLabel(
  strategy: AssistantTradeStrategy,
) {
  return (
    assistantTradeStrategyRegistry.find(item => item.key === strategy)?.label ??
    strategy
  )
}
